export enum RealTimeCountUpdate {
    REPLACE = "replace"
}